(() => {
  const dialog = document.querySelector('[data-rw-qb]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const content = dialog.querySelector('[data-rw-qb-content]');
  const status = dialog.querySelector('[data-rw-qb-status]');
  const link = dialog.querySelector('[data-rw-qb-link]');
  const root = window.Shopify?.routes?.root || '/';
  let data, selected, productUrl, opener, request, sequence = 0, busy = false;
  const q = selector => content.querySelector(selector);
  const message = key => dialog.dataset[key];
  const eligible = variant => variant.stock === null || variant.stock > 0;
  const maxQuantity = variant => Math.min(variant.stock ?? Infinity, variant.max ?? Infinity);
  const matchingVariant = () => data?.variants.find(v => v.options.every((value, i) => value === selected[i]));
  function close() {
    if (busy) return;
    request?.abort();
    sequence++;
    dialog.close();
  }
  dialog.addEventListener('close', () => {
    document.body.classList.remove('rw-qb-open');
    opener?.focus();
  });
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  dialog.querySelector('[data-rw-qb-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
  });
  function buttons(disabled) {
    content.querySelectorAll('button,input').forEach(el => { el.disabled = disabled; });
    dialog.querySelector('[data-rw-qb-close]').disabled = busy;
  }
  function renderOptions() {
    const container = q('[data-rw-qb-options]');
    container.replaceChildren();
    if (!data.default_only) {
      const indexes = data.options.map((_, i) => i);
      indexes.sort((a, b) => Number(/^(color|colour|colores)$/i.test(data.options[b])) - Number(/^(color|colour|colores)$/i.test(data.options[a])));
      let candidates = data.variants;
      indexes.forEach(index => {
        const values = [...new Set(candidates.map(v => v.options[index]))];
        if (!values.includes(selected[index])) selected[index] = values[0];
        const field = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = data.options[index];
        field.append(legend);
        const choices = document.createElement('div');
        choices.className = 'rw-qb__choices';
        values.forEach(value => {
          const label = document.createElement('label');
          label.className = 'rw-qb__option';
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = `rw-qb-option-${index}`;
          radio.value = value;
          radio.checked = value === selected[index];
          radio.dataset.optionIndex = index;
          const text = document.createElement('span');
          text.textContent = value;
          label.append(radio, text);
          choices.append(label);
        });
        field.append(choices);
        container.append(field);
        candidates = candidates.filter(v => v.options[index] === selected[index]);
      });
    }
    updateVariant();
  }
  function updateVariant() {
    const variant = matchingVariant();
    if (!variant) { status.textContent = message('soldOut'); buttons(true); return; }
    q('[data-rw-qb-price]').textContent = variant.price;
    const old = q('[data-rw-qb-old]');
    old.hidden = !variant.compare;
    old.textContent = variant.compare || '';
    const image = q('.rw-qb__image');
    if (image) {
      image.src = variant.image || image.dataset.originalSrc || image.src;
      image.removeAttribute('srcset');
    }
    const quantity = q('[name="quantity"]');
    quantity.min = variant.min;
    quantity.step = variant.step;
    const max = maxQuantity(variant);
    if (Number.isFinite(max)) quantity.max = max; else quantity.removeAttribute('max');
    quantity.value = variant.min;
    q('[data-rw-qb-stock]').textContent = variant.stock === null ? '' : `${message('stock')} ${variant.stock}`;
    const unavailable = max < variant.min;
    q('[data-rw-qb-add]').disabled = unavailable;
    q('[data-rw-qb-buy]').disabled = unavailable;
    status.textContent = unavailable ? message('soldOut') : '';
  }
  async function fetchProduct(url, signal) {
    const endpoint = new URL(url, window.location.origin);
    if (endpoint.origin !== window.location.origin) throw new Error(message('error'));
    endpoint.searchParams.set('section_id', 'royal-quick-buy');
    endpoint.searchParams.set('_rwqb', Date.now());
    const response = await fetch(endpoint.toString(), { signal, cache: 'no-store' });
    if (!response.ok) throw new Error(message('error'));
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const json = html.querySelector('[data-rw-qb-data]');
    const product = html.querySelector('[data-rw-qb-product]');
    if (!json || !product) throw new Error(message('error'));
    const value = JSON.parse(json.textContent);
    value.variants = value.variants.filter(eligible);
    return { product, value };
  }
  async function open(trigger) {
    if (busy) return;
    opener = trigger;
    productUrl = trigger.dataset.productUrl;
    link.href = productUrl;
    content.replaceChildren();
    status.textContent = message('loading');
    request?.abort();
    request = new AbortController();
    const current = ++sequence;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('rw-qb-open');
    try {
      const result = await fetchProduct(productUrl, request.signal);
      if (current !== sequence || !dialog.open) return;
      data = result.value;
      content.append(result.product);
      const image = q('.rw-qb__image');
      if (image) image.dataset.originalSrc = image.src;
      if (!data.variants.length) { status.textContent = message('soldOut'); buttons(true); return; }
      selected = [...data.variants[0].options];
      status.textContent = '';
      renderOptions();
    } catch (error) {
      if (error.name !== 'AbortError' && current === sequence) status.textContent = message('error');
    }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-rw-quick-buy]');
    if (trigger) { event.preventDefault(); open(trigger); }
  });
  function revealButtons() {
    document.querySelectorAll('[data-rw-quick-buy][hidden]').forEach(el => { el.hidden = false; });
  }
  revealButtons();
  const grid = document.querySelector('[data-rw-infinite-grid]');
  if (grid) new MutationObserver(revealButtons).observe(grid, { childList: true });
  content.addEventListener('change', event => {
    if (!event.target.matches('[data-option-index]') || busy) return;
    const index = Number(event.target.dataset.optionIndex);
    const value = event.target.value;
    selected[index] = value;
    renderOptions();
    const replacement = [...content.querySelectorAll('[data-option-index]')].find(el => Number(el.dataset.optionIndex) === index && el.value === value);
    replacement?.focus();
  });
  content.addEventListener('click', event => {
    if (busy) return;
    const delta = event.target.closest('[data-rw-qb-plus]') ? 1 : event.target.closest('[data-rw-qb-minus]') ? -1 : 0;
    if (!delta) return;
    const input = q('[name="quantity"]');
    const variant = matchingVariant();
    const next = (Number(input.value) || variant.min) + delta * variant.step;
    const max = maxQuantity(variant);
    const validMax = Number.isFinite(max) ? variant.min + Math.floor((max - variant.min) / variant.step) * variant.step : Infinity;
    input.value = Math.max(variant.min, Math.min(validMax, next));
  });
  content.addEventListener('submit', async event => {
    if (!event.target.matches('[data-rw-qb-form]')) return;
    event.preventDefault();
    if (busy) return;
    const variant = matchingVariant();
    const input = q('[name="quantity"]');
    if (!variant || !input.reportValidity()) return;
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < variant.min || (quantity - variant.min) % variant.step || quantity > maxQuantity(variant)) return;
    const buyNow = event.submitter?.matches('[data-rw-qb-buy]');
    busy = true;
    buttons(true);
    status.textContent = message('adding');
    let added = false;
    try {
      const fresh = await fetchProduct(productUrl);
      const current = fresh.value.variants.find(v => v.id === variant.id);
      if (!current || quantity > maxQuantity(current)) throw new Error(message('addError'));
      const before = await fetch(root + 'cart.js', { cache: 'no-store' });
      if (!before.ok) throw new Error(message('addError'));
      const cartBefore = await before.json();
      const existing = cartBefore.items.filter(item => String(item.variant_id) === String(variant.id)).reduce((sum, item) => sum + item.quantity, 0);
      if (existing + quantity > maxQuantity(current)) throw new Error(message('addError'));
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity }] }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || message('addError'));
      added = true;
      if (buyNow) { window.location.assign(root + 'checkout'); return; }
      const updated = await fetch(root + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } });
      if (!updated.ok) throw new Error(message('added'));
      const cart = await updated.json();
      busy = false;
      close();
      document.dispatchEvent(new CustomEvent('royal:quick-buy-added', { detail: { cart } }));
    } catch (error) {
      status.textContent = added ? message('added') : error.message || message('addError');
      if (added) link.href = dialog.dataset.cartUrl;
    } finally {
      busy = false;
      buttons(added);
      dialog.querySelector('[data-rw-qb-close]').disabled = false;
    }
  });
})();
